/* v1778718338 */
// Journal article template — interactivity layer.
// Builds TOC from H2 elements, scroll-spy highlighting, mobile toggle, copy-link button.

(function() {
  'use strict';

  function slugify(text) {
    return text.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function buildTOC() {
    var tocList = document.querySelector('.journal-toc__list');
    var content = document.querySelector('[data-journal-content]');
    if (!tocList || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) {
      // No TOC if fewer than 2 H2s
      var tocBlock = document.querySelector('[data-journal-toc]');
      if (tocBlock) tocBlock.style.display = 'none';
      return;
    }

    headings.forEach(function(h, i) {
      var text = h.textContent.trim();
      var id = h.id || slugify(text) || ('section-' + i);
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;
      a.setAttribute('data-toc-target', id);
      li.appendChild(a);
      tocList.appendChild(li);
    });

    setupTOCToggle();
    setupScrollSpy(headings);
  }

  function setupTOCToggle() {
    var toggle = document.querySelector('.journal-toc__toggle');
    var nav = document.querySelector('.journal-toc__nav');
    if (!toggle || !nav) return;

    // On desktop, always expanded
    var mql = window.matchMedia('(min-width: 1024px)');
    function syncDesktopState() {
      if (mql.matches) {
        nav.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    }
    syncDesktopState();
    mql.addEventListener('change', syncDesktopState);

    toggle.addEventListener('click', function() {
      if (mql.matches) return; // No-op on desktop
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.hidden = expanded;
    });
  }

  function setupScrollSpy(headings) {
    var links = document.querySelectorAll('[data-toc-target]');
    if (!('IntersectionObserver' in window) || links.length === 0) return;

    var current = null;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (current) current.classList.remove('is-active');
          var link = document.querySelector('[data-toc-target="' + entry.target.id + '"]');
          if (link) {
            link.classList.add('is-active');
            current = link;
          }
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

    headings.forEach(function(h) { observer.observe(h); });
  }

  function setupCopyLink() {
    var btn = document.querySelector('.journal-share__copy');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var url = btn.getAttribute('data-copy-url');
      if (!url) return;
      navigator.clipboard.writeText(url).then(function() {
        var orig = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(function() { btn.textContent = orig; }, 1500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      buildTOC();
      setupCopyLink();
    });
  } else {
    buildTOC();
    setupCopyLink();
  }
})();
